import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=345e52b8&lang=pug&"
import script from "./ProductGallery.vue?vue&type=script&lang=js&"
export * from "./ProductGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VItem,VItemGroup,VSheet})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
